import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatchTimePipe} from './match-time.pipe';

@NgModule({
  declarations: [MatchTimePipe],
  imports: [CommonModule],
  exports: [MatchTimePipe],
})
export class MatchTimeModule {}
